import { Inject, Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class ValidInvoiceTrackingIDGuard implements CanActivate {

    constructor(
      @Inject('INVOICE_TRACKING_KEY') private invoiceTrackingKey: string,
      private router: Router,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      // check if invoiceTrackingKey in the URL matches @Inject
      if (route.params.invoiceTrackingKey !== this.invoiceTrackingKey)  {
        this.router.navigateByUrl('/error');
        return false;
      }

      return true;
    }
}
